import { useFetchDashboardPaymentStatistic } from '@hooks';
import { ChartData, ChartOptions } from 'chart.js';
import { map } from 'lodash';
import React, { memo, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import trans from 'translation';
import { KContainer, KColors } from 'uikit';
import Loading from 'uikit/uikit/Loading';

import Today from '../components/Today';

const Payment = () => {
  const { data, isLoading } = useFetchDashboardPaymentStatistic();

  const chartData: ChartData<'bar'> = useMemo(() => {
    return {
      labels: map(data, 'date'),
      datasets: [
        {
          label: trans('total'),
          data: data?.map((item: any) => item.totalPayment ?? 0),
          backgroundColor: '#0263FF'
        },
        {
          label: trans('synced'),
          data: data?.map((item: any) => item.syncedPayment ?? 0),
          backgroundColor: '#0B9694'
        }
      ]
    };
  }, [data]);

  const options: ChartOptions<'bar'> = useMemo(
    () => ({
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: trans('total_amount'),
          align: 'start',
          font: {
            size: 12,
            weight: 'normal'
          },
          color: KColors.black
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 12,
            padding: 20,
            color: KColors.black
          },
          font: {
            size: 12,
            weight: 'normal'
          },
          display: true
        },
        tooltip: {
          mode: 'index',
          intersect: false
        }
      },
      scales: {
        x: {
          ticks: {
            font: {
              size: 12,
              weight: 'normal'
            },
            color: KColors.black
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            callback: (value: number) => '$' + value.toLocaleString(),
            font: {
              size: 12,
              weight: 'normal'
            },
            color: KColors.black
          }
        }
      },
      barThickness: 25
    }),
    []
  );

  return (
    <KContainer.Card
      height={250}
      marginT={0}
      dp="flex"
      header={{
        title: trans('payment'),
        typo: 'TextMdBold',
        rightNode: <Today />
      }}
    >
      <KContainer.View height="100%">
        {isLoading && <Loading />}
        <Bar data={chartData} options={options} />
      </KContainer.View>
    </KContainer.Card>
  );
};

export default memo(Payment);
